import { useEffect } from "react";
import { buildMeta } from "../lib/seo";

/**
 * Per-route metadata (template §7 / §0.2: "Every route owns its metadata").
 *
 * In Mode B the tags are applied to the live document rather than emitted into static HTML. The
 * component is deliberately shaped so that swapping to a Mode A prerender later is a change of
 * mechanism, not of call sites: every page already declares its own title and description here.
 */
export default function Seo({ title, description, path, noindex = true }) {
  useEffect(() => {
    const meta = buildMeta({ title, description, path, noindex });
    document.title = meta.title;

    const set = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };

    set('meta[name="description"]', { name: "description", content: meta.description });
    set('meta[name="robots"]', { name: "robots", content: meta.robots });

    if (meta.canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", meta.canonical);
    }
  }, [title, description, path, noindex]);

  return null;
}
